import React from 'react';

import BucketHeader from '../containers/header/BucketHeader';
import BucketCover from '../containers/cover/BucketCover';
import BucketMembers from '../containers/bucketMembers/BucketMembers';

import isAuthorizedCurrentBucket from '../hoc/CurrentBucketAuthorization';

const BucketMembersPage = () => {
    return (
        <React.Fragment>
            <BucketHeader />
            <BucketCover />
            <BucketMembers />
        </React.Fragment>
    );
};

export default isAuthorizedCurrentBucket(BucketMembersPage);



// WEBPACK FOOTER //
// ./src/pages/BucketMembersPage.js